import React from "react";
import { useNavigate } from "react-router-dom";
import "../style/landing.css";
import { Container, Row, Col, Button, Card } from "react-bootstrap";
import NewsletterSignup from "./newsletter";
import ItemPreview from "./itemsPreview";

function LandingPage() {
  const navigate = useNavigate();

  const FeatureCard = ({ title, text, icon }) => (
      <Card className="p-4 shadow" onClick={() => navigate("/pricing")}>
        <Card.Body>
          <Card.Title><i className={icon}></i> {title}</Card.Title>
          <Card.Text>{text}</Card.Text>
        </Card.Body>
      </Card>
    );

  return (
    <>
      {/* Top Hero Section */}
      <section className="main-banner text-center text-md-start py-5 landing-padding">
        <Container>
          <Row className="align-items-center">
            <Col xs={12} md={6} className="mb-4 mb-md-0">
              <h1 className="fw-bold hero-title">Empower Your Financial Future</h1>
              <p className="mt-3 hero-text">
              Wengmack Investmnt Tajirisha program is here to walk with you towards achieving your financial goals. Start your journey today! 
              </p>
              <Button variant="primary" className="mt-3" href="/login">Get Started <i className="bi bi-arrow-right"></i></Button>
            </Col>
            <Col xs={12} md={6} className="text-center">
              <img
                src="/images/mainLogo.svg"
                alt="Finance Illustration"
                className="img-fluid rounded hero-image"
              />
            </Col>
          </Row>
        </Container>
      </section>
      <section className="landingSignupSection">
        <NewsletterSignup />
      </section>

      {/* Unlock Financial Success Section */}
      <section className="text-center py-5 bg-light landing-padding dashboard-landing">
        <Container>
          <h2 className="fw-bold section-title">Unlock financial success with our products</h2>
          <p className="mb-4 section-text">
          Define your goals <i className="bi bi-caret-right"></i> Set your timeline <i className="bi bi-caret-right"></i> Track your progress.</p>
          <p className="section-text">Start your plan today and make your financial dreams a reality! 
          Stand a chance to get rewarded when you start your financial goal. Every 50 bob you save earns you 1 tajirisha point.
          </p>
          <div className="dashboard-image-container">
            <img
              src="/images/dashboard.jpg"
              alt="Dashboard Mockup"
              className="img-fluid rounded shadow dashboard-image"
            />
          </div>
        </Container>
      </section>

      {/* Celebrating Together Success Section */}
      <section className="text-center py-5 landing-padding dashboard-landing">
        <Container>
          <h2 className="fw-bold section-title">Celebrating Together</h2>
          <div className="celebration-image-container mb-4">
            <img
              src="/images/busket.png"
              alt="Dashboard Mockup"
              className="img-fluid rounded celebration-image"
            />
          </div>
          <p className="mb-4 section-text">
          Whether you're wishing for a holiday getaway, a money bouquet, the latest iPhone, new electronics, or even your dream car.
          </p>
          <ul className="celebration-list">
            <li>Register <a href="/signUp">Here</a></li>
            <li>Create a Birthday Wishlist to set Your Target</li>
            <li>Save as low as Ksh.150 every week</li>
            <li>Get Notified When Your Achieve Your Goal</li>
          </ul>
          <div className="text-start text-md-center benefits-section">
            <p><i className="bi bi-airplane"></i> Save & Earn Points to Win a Trip to Dubai or 2,000,000 every Week</p>
            <p><i className="bi bi-people-fill"></i> You Can Save For Yourself and the People You Care About (Your Child, Spouse, Partner, Friend, Sibling) </p>
            <p><i className="bi bi-cash"></i> Refer a Friend & Get Ksh.1000 Cash and 40 points </p>
          </div>
        </Container>
      </section>

      <section className="text-center py-5 landing-padding dashboard-landing">
        <ItemPreview />
      </section>
      {/* Invest with Confidence Section */}
      <section className="py-5 landing-padding">
        <Container>
            <Row className="justify-content-center align-items-center">
                {/* Left Column - Text Content */}
                <Col xs={12} lg={6} className="landing-opt-left mb-4 mb-lg-0">
                    <h3 className="fw-bold section-title text-center text-lg-start"> Invest with Confidence, Succeed with Ease</h3>
                    <p className="mb-4 section-text">
                    Save and reach your goals with ease every year - whether it's an anniversary, vacation, school fees, emergency fund or even buying a plot of land.
                    </p>
                    <p className="section-text">
                    You can start small. Create a savings plan from as low as 150 bob per week.
                    </p>
                </Col>

                {/* Right Column - Nested Row & Columns for Cards */}
                <Col xs={12} lg={6}>
                    <Row className="g-3">
                        <Col xs={12} sm={6}>
                            <FeatureCard title="Short term" text="Suitable for birthdays, valentine, gifts..." icon="bi bi-1-square" />
                        </Col>
                        <Col xs={12} sm={6}>
                            <FeatureCard title="Medium term" text="Suitable for School fees⁠, Insurance..." icon="bi bi-2-square"/>
                        </Col>
                        <Col xs={12} sm={6}>
                            <FeatureCard title="Long term" text="Suitable for Land, ⁠Car, retirement..." icon="bi bi-3-square"/>
                        </Col>
                        <Col xs={12} sm={6}>
                            <FeatureCard title="24/7 Support" text="We're here to assist you anytime, anywhere." icon="bi bi-telephone"/>
                        </Col>
                    </Row>
                </Col>
            </Row>
        </Container>
      </section>
    </>
  );
}

export default LandingPage;
